import { ShowroomSeason } from "@models/types/enums";

const seasonMap: Record<
  number,
  { season: ShowroomSeason; yearOffset: number }
> = {
  1: { season: "PRE_AW", yearOffset: 0 },
  2: { season: "AW", yearOffset: 0 },
  3: { season: "AW", yearOffset: 0 },
  4: { season: "PRE_SS", yearOffset: 0 },
  5: { season: "PRE_SS", yearOffset: 0 },
  6: { season: "SS", yearOffset: 0 },
  7: { season: "SS", yearOffset: 0 },
  8: { season: "SS", yearOffset: 0 },
  9: { season: "SS", yearOffset: 0 },
  10: { season: "SS", yearOffset: 0 },
  11: { season: "PRE_AW", yearOffset: 1 },
  12: { season: "PRE_AW", yearOffset: 1 },
};

type SeasonYear = {
  season: ShowroomSeason;
  year: number;
};

type UpcomingSeason = SeasonYear & {
  brandId?: string;
};

/**
 * Get the current wholesales season and year
 * @returns SeasonYear
 */
export function currentWholesalesSeasonYear(
  now: Date = new Date(),
): SeasonYear {
  const month = now.getMonth() + 1; // Current month (1-12)
  const year = now.getFullYear();

  return {
    season: seasonMap[month].season,
    year: seasonMap[month].yearOffset + year,
  };
}

export function getNextSeasonYear(seasonYear: SeasonYear): SeasonYear {
  switch (seasonYear.season) {
    case "PRE_AW":
      return { season: "AW", year: seasonYear.year };
    case "AW":
      return { season: "PRE_SS", year: seasonYear.year };
    case "PRE_SS":
      return { season: "SS", year: seasonYear.year };
    case "SS":
      return { season: "PRE_AW", year: seasonYear.year + 1 };
    default:
      throw new Error(`Invalid season: ${seasonYear.season}`);
  }
}

// function to calculate the next four fashion show seasons based on today's date
export const getNextFourFashionShows = (
  currentDate: Date,
  brandId?: string,
) => {
  const currentSeasonYear = currentWholesalesSeasonYear(currentDate);
  const upcomingSeasons: UpcomingSeason[] = [];

  for (let i = 0; i < 4; i++) {
    const nextSeasonYear = getNextSeasonYear(currentSeasonYear);
    upcomingSeasons.push({ ...nextSeasonYear, brandId });
  }

  return upcomingSeasons;
};
